import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import JuridicalPersonUpdateComponent from './JuridicalPersonUpdate.component';
import JuridicalPerson from 'src/entities/JuridicalPerson';
import {
  updateJuridicalPerson,
  UpdateJuridicalPersonAction,
  UpdateJuridicalPersonSuccess,
} from 'src/actions/juridical-person/update/UpdateJuridicalPerson.actions';
import {
  changeJuridicalPersonData,
  ChangeJuridicalPersonDataAction
} from 'src/actions/juridical-person/change-data/ChangePhysicalPersonData.actions';
import {
  createJuridicalPerson,
  CreateJuridicalPersonAction,
  CreateJuridicalPersonSuccess,
} from 'src/actions/juridical-person/create/CreateJuridicalPerson.actions';
import PhysicalPerson from 'src/entities/PhysicalPerson';
import * as moment from 'moment';
import Spouse from 'src/value-objects/Spouse';
import { getImage, GetImageAction, GetImageSuccess } from 'src/actions/image/get/GetImage.actions';
import JuridicalPersonData from 'src/value-objects/JuridicalPersonData';
import * as updateJuridicalPersonTypes from 'src/actions/juridical-person/update/Types';
import * as createJuridicalPersonTypes from 'src/actions/juridical-person/create/Types';
import Base64Encoder from 'src/services/encoders/Base64Encoder';
import Person from 'src/entities/Person';
import { ChangeDefaultProfileAction, changeDefaultProfile }
  from 'src/actions/default-profile/change/ChangeDefaultProfile.actions';
import * as changeDefaultProfileTypes from 'src/actions/default-profile/change/Types';
import {
  getJuridicalPerson,
  GetJuridicalPersonAction
} from 'src/actions/juridical-person/get/GetJuridicalPerson.actions';
import { match } from 'react-router';
import { getUser, GetUserAction } from 'src/actions/user/get/GetUser.actions';
import { getPhysicalPerson, GetPhysicalPersonAction } from 'src/actions/physical-person/get/GetPhysicalPerson.actions';
import * as getUserTypes from 'src/actions/user/get/Types';
import User from 'src/entities/User';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';

interface StateProps {
  formData?: JuridicalPersonData;
  juridicalPerson?: JuridicalPerson;
  physicalPerson?: PhysicalPerson;
  loggedUserData: number | null;
  error: boolean;
  createErrorMessages: {};
  updateErrorMessages: {};
  defaultProfile?: Person;
  user?: User;
}

interface DispatchProps {
  changeDefaultProfile: (userId: number, id: number, personType: string) => Promise<ChangeDefaultProfileAction>;

  updateJuridicalPerson(juridicalPerson: JuridicalPersonData): Promise<UpdateJuridicalPersonAction>;

  changeJuridicalPersonData(juridicalPerson: JuridicalPersonData): ChangeJuridicalPersonDataAction;

  createJuridicalPerson(juridicalPerson: JuridicalPersonData): Promise<CreateJuridicalPersonAction>;

  getImage(imageName: string): Promise<GetImageAction>;

  getJuridicalPerson(juridicalPersonId: number): Promise<GetJuridicalPersonAction>;

  getUser(userId: number): Promise<GetUserAction>;

  getPhysicalPerson(physicalPersonId: number): Promise<GetPhysicalPersonAction>;
}

interface OwnProps {
  match: match<{ personId: number }>;
}

interface Props extends StateProps, DispatchProps, OwnProps {
}

interface State {
  success?: boolean;
  cifDocument?: File;
  cifDocumentName?: string;
  deedCompany?: File;
  deedCompanyName?: string;
  companyStatutes?: File;
  companyStatutesName?: string;
  realOwnership?: File;
  realOwnershipName?: string;
  idRepresentatives?: File;
  idRepresentativesName?: string;
  notarialDeed?: File;
  notarialDeedName?: string;
  idFront?: File;
  idFrontName?: string;
  idBack?: File;
  idBackName?: string;
  profilePicture?: File;
  profilePictureName?: string;
  checkboxState: boolean;
  canChangeCheckbox: boolean;
}

interface StateProps {
  lockCreateJuridicalPerson: boolean;
}

class JuridicalPersonUpdateContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeSpouse = this.handleChangeSpouse.bind(this);
    this.handleChangeDefaultProfile = this.handleChangeDefaultProfile.bind(this);
    this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this);
    this.handlePublicProfileCheckbox = this.handlePublicProfileCheckbox.bind(this);
  }

  public componentWillMount(): void {

    if (this.props.match.params.personId) {
      this.props.getJuridicalPerson(this.props.match.params.personId);
    }

    if (!this.props.physicalPerson) {
      const userId = this.props.loggedUserData!;
      this.props.getUser(userId).then((response) => {
        if (response.type === getUserTypes.GET_USER_SUCCESS) {
          this.props.getPhysicalPerson(response.payload.physicalPersonId);
        }
      });
    }

    if (this.props.juridicalPerson) {
      this.props.changeJuridicalPersonData(new JuridicalPersonData(this.props.juridicalPerson));
      this.getImages(this.props.juridicalPerson);
    } else {
      if (this.props.physicalPerson) {
        this.props.formData!.userId = this.props.loggedUserData!;
        this.props.formData!.email = this.props.physicalPerson!.email;
        this.props.formData!.companyProxyIncluded = false;
        this.props.changeJuridicalPersonData(new JuridicalPersonData(this.props.formData!));
      }
    }

    this.setState(
      { success: false }
    );
  }

  public componentWillReceiveProps(newProps: Props): void {
    if (this.props.juridicalPerson !== newProps.juridicalPerson) {
      if (newProps.juridicalPerson) {

        this.props.changeJuridicalPersonData(new JuridicalPersonData(newProps.juridicalPerson));
        this.getImages(newProps.juridicalPerson);

        const isChecked = newProps.defaultProfile && newProps.juridicalPerson &&
          newProps.defaultProfile.personType === 'juridical'
          && newProps.defaultProfile.id === newProps.juridicalPerson!.id;
        const canChange = !isChecked;
        this.setState({ checkboxState: isChecked!, canChangeCheckbox: canChange });

      }
    }
  }

  public render(): React.ReactNode {
    return (
      this.props.physicalPerson ? (
        <JuridicalPersonUpdateComponent
          formData={this.props.formData!}
          juridicalPerson={this.props.juridicalPerson}
          error={this.props.error}
          errorMessage={this.props.formData!.id ? this.props.updateErrorMessages : this.props.createErrorMessages}
          success={this.state.success!}
          physicalPerson={this.props.physicalPerson}
          profilePicture={this.state.profilePicture}
          cifDocument={this.state.cifDocument}
          cifDocumentName={this.state.cifDocumentName}
          deedCompany={this.state.deedCompany}
          deedCompanyName={this.state.deedCompanyName}
          companyStatutes={this.state.companyStatutes}
          companyStatutesName={this.state.companyStatutesName}
          realOwnership={this.state.realOwnership}
          realOwnershipName={this.state.realOwnershipName}
          idRepresentatives={this.state.idRepresentatives}
          idRepresentativesName={this.state.idRepresentativesName}
          notarialDeed={this.state.notarialDeed}
          notarialDeedName={this.state.notarialDeedName}
          idFront={this.state.idFront}
          idFrontName={this.state.idFrontName}
          idBack={this.state.idBack}
          idBackName={this.state.idBackName}
          defaultProfile={this.props.defaultProfile!}
          checkboxState={this.state.checkboxState}
          canChangeCheckbox={this.state.canChangeCheckbox}
          handleSubmit={this.handleSubmit}
          handleChange={this.handleChange}
          handleChangeSpouse={this.handleChangeSpouse}
          handleChangeDefaultProfile={this.handleChangeDefaultProfile}
          handleChangeCheckbox={this.handleChangeCheckbox}
          handlePublicProfileCheckbox={this.handlePublicProfileCheckbox}
          lockCreateJuridicalPerson={this.props.lockCreateJuridicalPerson}
        />
      ) :
        <LoadingContainer />
    );
  }

  private handleSubmit(edit: boolean): void {
    if (edit) {
      this.props.updateJuridicalPerson(this.props.formData!).then((response: UpdateJuridicalPersonSuccess) => {
        if (response.type === updateJuridicalPersonTypes.UPDATE_JURIDICAL_PERSON_SUCCESS) {
          if (this.state.checkboxState === true) {
            this.handleChangeDefaultProfile();
          }
          this.setState(
            { success: true }
          );
        }
      });
    } else {
      this.props.formData!.userId = this.props.loggedUserData!;
      this.props.createJuridicalPerson(this.props.formData!).then((response: CreateJuridicalPersonSuccess) => {
        if (response.type === createJuridicalPersonTypes.CREATE_JURIDICAL_PERSON_SUCCESS) {
          if (this.state.checkboxState === true) {
            this.handleChangeDefaultProfile();
          }
          this.setState(
            { success: true }
          );
        }
      });
    }
  }

  private getImages(data: JuridicalPerson): void {
    if (data.profilePicture) {
      this.props.getImage(data.profilePicture).then((response: GetImageSuccess) => {
        if (response.type === 'GET_IMAGE_SUCCESS') {
          this.setState({ profilePicture: response.payload });
        }
      });
    }
    if (data.idFront) {
      this.props.getImage(data.idFront).then((response: GetImageSuccess) => {
        if (response.type === 'GET_IMAGE_SUCCESS') {
          this.setState({ idFront: response.payload });
        }
      });
    }
    if (data.idBack) {
      this.props.getImage(data.idBack).then((response: GetImageSuccess) => {
        if (response.type === 'GET_IMAGE_SUCCESS') {
          this.setState({ idBack: response.payload });
        }
      });
    }
    if (data.cifDocumentImage) {
      this.props.getImage(data.cifDocumentImage).then((response: GetImageSuccess) => {
        if (response.type === 'GET_IMAGE_SUCCESS') {
          this.setState({ cifDocument: response.payload });
        } else {
          this.setState({ cifDocumentName: data.cifDocument, cifDocument: response.payload });
        }
      });
    }
    if (data.deedCompanyImage) {
      this.props.getImage(data.deedCompanyImage).then((response: GetImageSuccess) => {
        if (response.type === 'GET_IMAGE_SUCCESS') {
          this.setState({ deedCompany: response.payload });
        } else {
          this.setState({ deedCompanyName: data.deedCompany, deedCompany: response.payload });
        }
      });
    }
    if (data.companyStatutesImage) {
      this.props.getImage(data.companyStatutesImage).then((response: GetImageSuccess) => {
        if (response.type === 'GET_IMAGE_SUCCESS') {
          this.setState({ companyStatutes: response.payload });
        } else {
          this.setState({ companyStatutes: response.payload, companyStatutesName: data.companyStatutes });
        }
      });
    }
    if (data.realOwnershipImage) {
      this.props.getImage(data.realOwnershipImage).then((response: GetImageSuccess) => {
        if (response.type === 'GET_IMAGE_SUCCESS') {
          this.setState({ realOwnership: response.payload });
        } else {
          this.setState({ realOwnership: response.payload, realOwnershipName: data.realOwnership });
        }
      });
    }
    if (data.idRepresentativesImage) {
      this.props.getImage(data.idRepresentativesImage).then((response: GetImageSuccess) => {
        if (response.type === 'GET_IMAGE_SUCCESS') {
          this.setState({ idRepresentatives: response.payload });
        } else {
          this.setState({ idRepresentatives: response.payload, idRepresentativesName: data.idRepresentatives });
        }
      });
    }
    if (data.notarialDeedImage) {
      this.props.getImage(data.notarialDeedImage).then((response: GetImageSuccess) => {
        if (response.type === 'GET_IMAGE_SUCCESS') {
          this.setState({ notarialDeed: response.payload });
        } else {
          this.setState({ notarialDeed: response.payload, notarialDeedName: data.notarialDeed });
        }
      });
    }
  }

  private handleChangeDefaultProfile(): void {
    const userId = this.props.loggedUserData!;
    
    let id = this.props.juridicalPerson ? 
      this.props.juridicalPerson.id : 
      (this.props.formData && this.props.formData.id ? this.props.formData.id : null);

    if (id) {
      this.props.changeDefaultProfile(
        userId, id, 'juridical').then(
          (response: ChangeDefaultProfileAction) => {
            if (response.type === changeDefaultProfileTypes.CHANGE_DEFAULT_PROFILE_SUCCESS) {
              this.setState({ success: true });
            }
          });
    }
  }

  private handleChangeCheckbox(): void {
    if (!this.state.canChangeCheckbox) {
      return;
    }
    this.setState({ checkboxState: !this.state.checkboxState });
  }

  private handleChange(key: string): (value: string | boolean | File | Person | moment.Moment) => void {
    switch (key) {
      case 'idExpirationDate':
        return (value: moment.Moment) => {
          this.props.formData!.idExpirationDate = value;
          this.props.changeJuridicalPersonData(new JuridicalPersonData(this.props.formData!));
        };
      case 'birthDate':
        return (value: moment.Moment) => {
          this.props.formData!.birthDate = value;
          this.props.changeJuridicalPersonData(new JuridicalPersonData(this.props.formData!));
        };
      case 'establishmentDate':
        return (value: moment.Moment) => {
          this.props.formData!.establishmentDate = value;
          this.props.changeJuridicalPersonData(new JuridicalPersonData(this.props.formData!));
        };
      case 'establishmentRepresentativeDate':
        return (value: moment.Moment) => {
          this.props.formData!.establishmentRepresentativeDate = value;
          this.props.changeJuridicalPersonData(new JuridicalPersonData(this.props.formData!));
        };
      case 'cifDocument':
        return (value: File) => {
          this.setState({ cifDocument: undefined, cifDocumentName: value.name });
          Base64Encoder.encode(value).then((result) => {
            let newImage = {
              url: URL.createObjectURL(value),
              encoded: result.split('base64,')[1],
              ext: value.type.split('/')[1],
              name: value.name,
            };
            this.props.formData!.cifDocument = newImage;
            this.props.changeJuridicalPersonData(new JuridicalPersonData(this.props.formData!));
          });
        };
      case 'deedCompany':
        return (value: File) => {
          this.setState({ deedCompany: undefined, deedCompanyName: value.name });
          Base64Encoder.encode(value).then((result) => {
            let newImage = {
              url: URL.createObjectURL(value),
              encoded: result.split('base64,')[1],
              ext: value.type.split('/')[1],
              name: value.name,
            };
            this.props.formData!.deedCompany = newImage;
            this.props.changeJuridicalPersonData(new JuridicalPersonData(this.props.formData!));
          });
        };
      case 'companyStatutes':
        return (value: File) => {
          this.setState({ companyStatutes: undefined, companyStatutesName: value.name });
          Base64Encoder.encode(value).then((result) => {
            let newImage = {
              url: URL.createObjectURL(value),
              encoded: result.split('base64,')[1],
              ext: value.type.split('/')[1],
              name: value.name,
            };
            this.props.formData!.companyStatutes = newImage;
            this.props.changeJuridicalPersonData(new JuridicalPersonData(this.props.formData!));
          });
        };
      case 'realOwnership':
        return (value: File) => {
          this.setState({ realOwnership: undefined, realOwnershipName: value.name });
          Base64Encoder.encode(value).then((result) => {
            let newImage = {
              url: URL.createObjectURL(value),
              encoded: result.split('base64,')[1],
              ext: value.type.split('/')[1],
              name: value.name
            };
            this.props.formData!.realOwnership = newImage;
            this.props.changeJuridicalPersonData(new JuridicalPersonData(this.props.formData!));
          });
        };
      case 'idRepresentatives':
        return (value: File) => {
          this.setState({ idRepresentatives: undefined, idRepresentativesName: value.name });
          Base64Encoder.encode(value).then((result) => {
            let newImage = {
              url: URL.createObjectURL(value),
              encoded: result.split('base64,')[1],
              ext: value.type.split('/')[1],
              name: value.name
            };
            this.props.formData!.idRepresentatives = newImage;
            this.props.changeJuridicalPersonData(new JuridicalPersonData(this.props.formData!));
          });
        };
      case 'notarialDeed':
        return (value: File) => {
          this.setState({ notarialDeed: undefined, notarialDeedName: value.name });
          Base64Encoder.encode(value).then((result) => {
            let newImage = {
              url: URL.createObjectURL(value),
              encoded: result.split('base64,')[1],
              ext: value.type.split('/')[1],
              name: value.name
            };
            this.props.formData!.notarialDeed = newImage;
            this.props.changeJuridicalPersonData(new JuridicalPersonData(this.props.formData!));
          });
        };
      case 'idFront':
        return (value: File) => {
          this.setState({ idFront: value, idFrontName: value.name });
          Base64Encoder.encode(value).then((result) => {
            let newImage = {
              url: URL.createObjectURL(value),
              encoded: result.split('base64,')[1],
              ext: value.type.split('/')[1],
              name: value.name,
            };
            this.props.formData!.idFront = newImage;
            this.props.changeJuridicalPersonData(new JuridicalPersonData(this.props.formData!));
          });
        };
      case 'idBack':
        return (value: File) => {
          this.setState({ idBack: value, idBackName: value.name });
          Base64Encoder.encode(value).then((result) => {
            let newImage = {
              url: URL.createObjectURL(value),
              encoded: result.split('base64,')[1],
              ext: value.type.split('/')[1],
              name: value.name
            };
            this.props.formData!.idBack = newImage;
            this.props.changeJuridicalPersonData(new JuridicalPersonData(this.props.formData!));
          });
        };
      case 'profilePicture':
        return (value: File) => {
          this.setState({ profilePicture: value, profilePictureName: value.name });
          Base64Encoder.encode(value).then((result) => {
            let newImage = {
              url: URL.createObjectURL(value),
              encoded: result.split('base64,')[1],
              ext: value.type.split('/')[1],
              name: value.name
            };
            this.props.formData!.profilePicture = newImage;
            this.props.changeJuridicalPersonData(new JuridicalPersonData(this.props.formData!));
          });
        };
      case 'companyProxyIncluded':
        return (value: boolean) => {
          let newData = { ...this.props.formData!, [key]: !this.props.formData!.companyProxyIncluded };
          this.props.changeJuridicalPersonData(new JuridicalPersonData(newData));
        };
      case 'maritalStatus':
        return (value: string) => {
          if (value === 'Casado/a' && !this.props.formData!.spouse) {
            this.props.formData!.spouse = new Spouse({});
          }
          this.props.formData![key] = value;
          this.props.changeJuridicalPersonData(new JuridicalPersonData(this.props.formData!));
        };
      case 'copy':
        return (value: boolean) => {
          this.props.changeJuridicalPersonData(
            new JuridicalPersonData({
              ...this.props.formData!,
              ...this.props.physicalPerson!,
              id: this.props.formData!.id,
              personType: undefined
            })
          );
        };
      default:
        return (value: string | boolean) => {
          let newData = { ...this.props.formData!, [key]: value };
          this.props.changeJuridicalPersonData(new JuridicalPersonData(newData));
        };
    }
  }

  private handleChangeSpouse(key: string): (value: string | boolean | File | moment.Moment) => void {
    return (value: string | boolean) => {
      if (this.props.formData!.spouse) {
        let newData = {
          ...this.props.formData!,
          spouse: {
            ...this.props.formData!.spouse,
            [key]: value,
          }
        };
        this.props.changeJuridicalPersonData(new JuridicalPersonData(newData));
      }
    };
  }

  private handlePublicProfileCheckbox(): void {
    let newData = { ...this.props.formData!, isPublicProfile: !this.props.formData!.isPublicProfile };
    this.props.changeJuridicalPersonData(new JuridicalPersonData(newData));
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
    changeJuridicalPersonData: (juridicalPerson: JuridicalPersonData): ChangeJuridicalPersonDataAction => (
      dispatch(changeJuridicalPersonData(juridicalPerson))
    ),
    updateJuridicalPerson: (juridicalPerson: JuridicalPersonData): Promise<UpdateJuridicalPersonAction> => (
      dispatch(updateJuridicalPerson(juridicalPerson))
    ),
    createJuridicalPerson: (juridicalPerson: JuridicalPersonData): Promise<CreateJuridicalPersonAction> => (
      dispatch(createJuridicalPerson(juridicalPerson))
    ),
    getImage: (imageName: string): Promise<GetImageAction> => (
      dispatch(getImage(imageName))
    ),
    changeDefaultProfile: (userId: number, id: number, personType: string): Promise<ChangeDefaultProfileAction> => (
      dispatch(changeDefaultProfile(userId, id, personType))
    ),
    getJuridicalPerson: (juridicalPersonId): Promise<GetJuridicalPersonAction> => (
      dispatch(getJuridicalPerson(juridicalPersonId))
    ),
    getUser: (userId: number): Promise<GetUserAction> => (
      dispatch(getUser(userId))
    ),
    getPhysicalPerson: (physicalPersonId: number): Promise<GetPhysicalPersonAction> => (
      dispatch(getPhysicalPerson(physicalPersonId))
    ),
  });

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  juridicalPerson: state.getJuridicalPerson.juridicalPerson,
  physicalPerson: state.getPhysicalPerson.physicalPerson,
  formData: state.changeJuridicalPersonData.juridicalPerson,
  error: state.updateJuridicalPerson.error,
  updateErrorMessages: state.updateJuridicalPerson.errorMessage,
  createErrorMessages: state.createJuridicalPerson.errorMessage,
  loggedUserData: state.authentication.loggedUserData,
  defaultProfile: state.getUser.defaultProfile,
  lockCreateJuridicalPerson: state.createJuridicalPerson.loading,
});

export default connect(mapStateToProps, mapDispatchToProps)(JuridicalPersonUpdateContainer);



// WEBPACK FOOTER //
// ./src/modules/my-account/juridical-profile-update/JuridicalPersonUpdate.container.tsx